import cx from 'classnames';
import React from 'react';

import {
  roundedInnerModuleClasses,
  roundedOuterModuleClasses,
} from '../../components/module/Background';
import { Width } from '../../components/module/Width';
import { Wrapper } from '../../components/module/Wrapper';

export type WorkableApplicationFormProps = {
  children?: React.ReactElement;
  shortcode?: string;
};

export const WorkableApplicationForm = ({
  shortcode,
}: WorkableApplicationFormProps) => {
  return (
    <Wrapper theme={{ space: { top: 'none', bottom: 'lg' } }}>
      <Width
        width="inner"
        className={cx(
          'relative bg-[#F9F9F9] p-8 md:p-10 lg:p-12 xl:p-16',
          roundedOuterModuleClasses.top,
          roundedOuterModuleClasses.bottom,
        )}
      >
        <iframe
          title="Workable application form"
          src={`https://jobs.eu.lever.co/prima/${shortcode}/apply/`}
          className={cx(
            'w-full h-[2200px] border-0',
            roundedInnerModuleClasses.top,
            roundedInnerModuleClasses.bottom,
          )}
        />
      </Width>
    </Wrapper>
  );
};

export default React.memo(WorkableApplicationForm);
